import PropTypes from "prop-types"
import React from "react"
import { Modal, Grid, Button } from "semantic-ui-react"
import "./ConflictProposalModal.css"

export const ConflictProposalModal = props => {
  const { header, contentText, yesTextLabel, closeModal } = props

  return (
    <Modal
      defaultOpen={true}
      className="AskForConfirmation"
      closeOnDimmerClick={false}
      closeOnDocumentClick={false}
    >
      <Modal.Header style={{ fontWeight: "300" }}>{header}</Modal.Header>
      <Modal.Content>
        <p>{contentText}</p>
      </Modal.Content>
      <Modal.Actions>
        <Grid>
          <Grid.Row columns="equal">
            <Grid.Column textAlign="right">
              <Button
                content={yesTextLabel}
                primary
                onClick={() => closeModal(false)}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </Modal.Actions>
    </Modal>
  )
}

ConflictProposalModal.propTypes = {
  closeModal: PropTypes.func.isRequired,
  header: PropTypes.string,
  contentText: PropTypes.string,
  yesTextLabel: PropTypes.string
}

ConflictProposalModal.defaultProps = {
  header: "Request Failed",
  yesTextLabel: "Ok",
  contentText:
    "We're already working to create an action plan for you. Please wait until that is available before requesting a new one."
}
